////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, findIndex, map } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const campaignPrice = {
	[ActionsTypes.GET_CAMPAIGN]: (state) =>
		update(state, {
			campaignPrice: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.GET_CAMPAIGN_SUCCESS]: (state, payload) => {
		return update(state, {
			campaignPrice: {
				isLoading: {
					$set: false,
				},
				campaign: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.GET_CAMPAIGN_FAILURE]: (state, payload) =>
		update(state, {
			campaignPrice: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.UPDATE_CAMPAIGN]: (state) =>
		update(state, {
			campaignPrice: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.UPDATE_CAMPAIGN_SUCCESS]: (state, payload) => {
		// Put new data in store
		let current_campaigns = cloneDeep(state.scheduledPricesManager.items)

		map(current_campaigns, (elem, id) => {
			if (elem.id === payload.idCampaign) {
				current_campaigns[id] = payload.data
			}
		})

		return update(state, {
			campaignPrice: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				campaign: {
					$set: {},
				},
			},
			scheduledPricesManager: {
				items: {
					$set: current_campaigns,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_CAMPAIGN_FAILURE]: (state, payload) => {
		const campaignState = cloneDeep(state.campaignPrice.campaign.Items)
		const errors = payload.error.data

		errors.forEach((elem) => {
			let idxCampaignState = findIndex(campaignState, { lineNumber: elem.lineNumber })
			campaignState[idxCampaignState].errorDto = elem
		})

		return update(state, {
			campaignPrice: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.CANCEL_CAMPAIGN]: (state) =>
		update(state, {
			scheduledPricesManager: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.CANCEL_CAMPAIGN_SUCCESS]: (state, payload) => {
		// Put new data in store
		let current_campaigns = cloneDeep(state.scheduledPricesManager.items)

		map(current_campaigns, (elem, id) => {
			if (elem.id === payload.idCampaign) {
				current_campaigns[id] = payload.data
			}
		})

		return update(state, {
			scheduledPricesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				campaign: {
					$set: {},
				},
				items: {
					$set: current_campaigns,
				},
			},
		})
	},
	[ActionsTypes.CANCEL_CAMPAIGN_FAILURE]: (state, payload) => {
		return update(state, {
			scheduledPricesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},

	[ActionsTypes.CREATE_CAMPAIGN]: (state) =>
		update(state, {
			campaignPrice: {
				isLoading: {
					$set: true,
				},
				isSuccess: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.CREATE_CAMPAIGN_SUCCESS]: (state, _payload) => {
		return update(state, {
			campaignPrice: {
				isLoading: {
					$set: false,
				},
				isSuccess: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.CREATE_CAMPAIGN_FAILURE]: (state, payload) => {
		const campaignState = cloneDeep(state.campaignPrice.campaign.Items)
		const errors = payload.error.data

		errors.forEach((elem) => {
			let idxCampaignState = findIndex(campaignState, { lineNumber: elem.lineNumber })
			campaignState[idxCampaignState].errorDto = elem
		})

		return update(state, {
			campaignPrice: {
				isLoading: {
					$set: false,
				},
				isSuccess: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				campaign: {
					Items: {
						$set: campaignState,
					},
				},
			},
		})
	},

	[ActionsTypes.POST_CHECK_CAMPAIGN]: (state) =>
		update(state, {
			campaignPrice: {
				isLoading: {
					$set: true,
				},
				isSuccess: {
					$set: false,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_CHECK_CAMPAIGN_SUCCESS]: (state, payload) => {
		return update(state, {
			campaignPrice: {
				isLoading: {
					$set: false,
				},
				isSuccess: {
					$set: false,
				},
				campaign: {
					$set: payload.campaign,
				},
			},
		})
	},
	[ActionsTypes.POST_CHECK_CAMPAIGN_FAILURE]: (state, payload) =>
		update(state, {
			campaignPrice: {
				isLoading: {
					$set: false,
				},
				isSuccess: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_CAMPAIGN]: (state, _payload) =>
		update(state, {
			campaignPrice: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				campaign: {
					$set: {},
				},
				update: {
					$set: false,
				},
				isSuccess: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.RESET_CAMPAIGN_ITEMS]: (state) =>
		update(state, {
			campaignPrice: {
				campaign: {
					$set: {},
				},
			},
		}),
}

export default campaignPrice
